import React, { useMemo } from "react";
import { object, func, number } from "prop-types";
import moment from "moment";
import { FaLayerGroup } from "react-icons/fa";
import ReactTooltip from "react-tooltip";

import {
  watchListMatchStatusOptions,
  MONITORING_QUEUE_ENTRY_TYPES,
} from "../../../../../constants/monitoringQueueEntryConstants";
import { Badge } from "reactstrap";
import "./monitoringQueueEntrySearchDetailsTableRow.css";

function getMatchesCount(entry, type) {
  try {
    return (
      type !== MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_INFO &&
      type !== MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_ELASTIC_BASED &&
      entry.matchingEntries.length
    );
  } catch (error) {
    return undefined;
  }
}

const MonitoringQueueEntrySearchDetailsTableRow = ({
  entry,
  toggleDetails,
  type,
  canAddNegativeMediaIgnoringProperty,
}) => {
  const ignoringProp =
    type !== MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_INFO &&
    type !== MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_ELASTIC_BASED
      ? entry.watchListSearchingDecisionDto
      : entry.negativeMediaSearchingDecision;
  const actionButton = (
    <td className="center">
      <ReactTooltip id={`resolve-icon-${entry.id}`} type="info">
        <span>View all {getMatchesCount(entry, type)} matches</span>
      </ReactTooltip>
      <span className="matches-count-icon-wrapper">
        <FaLayerGroup
          size="1.3em"
          data-tip
          data-for={`resolve-icon-${entry.id}`}
          color="cornflowerblue"
          onClick={() => toggleDetails(entry)}
        />
        {!!getMatchesCount(entry, type) && (
          <Badge color="danger" pill className="matches-count-badge">
            {getMatchesCount(entry, type)}
          </Badge>
        )}
      </span>
    </td>
  );

  const getNegativeMediaUrl = (entry, type) => {
    var result = "";
    if (type === MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_INFO) {
      result = entry.url;
    }
    if (type === MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_ELASTIC_BASED) {
      var data = JSON.parse(entry.dataJson);
      if (data && data.Resolutions) {
        result = data.Resolutions[0].ArticleUrl;
      }
    }
    return result;
  };

  function hasNegativeMedia(clientNegativeMediaCheckResult, entry) {
    if (clientNegativeMediaCheckResult.url) {
      return clientNegativeMediaCheckResult.url;
    }
    if (clientNegativeMediaCheckResult.dataJson) {
      var data = JSON.parse(clientNegativeMediaCheckResult.dataJson);
      return data.IsPresented;
    }
    return false;
  }

  function getParentDate() {
    if (entry.negativeMediaSearchingDecision) {
      if (
        entry.negativeMediaSearchingDecision
          .parentNegativeMediaSearchingDecision
      ) {
        const date =
          entry.negativeMediaSearchingDecision
            .parentNegativeMediaSearchingDecision.createDate;
        return moment(date).format("DD.MM.YYYY");
      }
    } else if (entry.watchListSearchingDecisionDto) {
      if (
        entry.watchListSearchingDecisionDto.parentWatchListSearchingDecision
      ) {
        const date =
          entry.watchListSearchingDecisionDto.parentWatchListSearchingDecision
            .createDate;
        return moment(date).format("DD.MM.YYYY");
      }
    } else {
      return null;
    }
  }

  function getLowestPercent() {
    if (entry.matchingEntries && entry.matchingEntries.length) {
      const allPercents = entry.matchingEntries.map((x) => x.matchPercent);
      return Math.min(...allPercents).toString() + "%";
    }

    return null;
  }

  const isNegativeMedia = useMemo(() => {
    return (
      type === MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_INFO ||
      type === MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_ELASTIC_BASED
    );
  }, [type]);

  return (
    <React.Fragment>
      <tr>
        {isNegativeMedia ? (
          hasNegativeMedia(entry) ? (
            <td>
              {" "}
              <a target="_blank" href={getNegativeMediaUrl(entry, type)}>
                {
                  getNegativeMediaUrl(entry, type).match(
                    /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\n?=]+)/im,
                  )[1]
                }
              </a>{" "}
            </td>
          ) : (
            <td></td>
          )
        ) : (
          <td>{entry.name}</td>
        )}

        {!isNegativeMedia && <td>{entry.type}</td>}

        <td>
          {isNegativeMedia
            ? entry.client.clientParams.find((x) => x.name === "Client").value
            : entry.matchingEntries[0].name.fullName}
        </td>
        <td>
          {isNegativeMedia
            ? entry.createDate
              ? moment(entry.createDate).format("DD.MM.YYYY")
              : ""
            : entry.matchingEntries[0].birthDate
              ? moment(entry.matchingEntries[0].birthDate).format("DD.MM.YYYY")
              : ""}
        </td>
        {!isNegativeMedia ? <td> {getLowestPercent()}</td> : null}
        <td> {getParentDate()}</td>
        {type !== MONITORING_QUEUE_ENTRY_TYPES.WATCHLIST_MANUAL_SEARCH &&
          (isNegativeMedia && !hasNegativeMedia(entry) ? (
            <React.Fragment></React.Fragment>
          ) : ignoringProp ? (
            <td>
              {
                watchListMatchStatusOptions.find(
                  (to) => to.value === ignoringProp.type,
                ).label
              }
            </td>
          ) : (
            <td>
              {watchListMatchStatusOptions.find((to) => to.value === 0).label}
            </td>
          ))}

        {isNegativeMedia ? (
          canAddNegativeMediaIgnoringProperty &&
          (entry.url != null || entry.dataJson != null) ? (
            actionButton
          ) : (
            <React.Fragment></React.Fragment>
          )
        ) : type ? (
          actionButton
        ) : (
          <React.Fragment></React.Fragment>
        )}
      </tr>
    </React.Fragment>
  );
};
MonitoringQueueEntrySearchDetailsTableRow.propTypes = {
  entry: object.isRequired,
  toggleDetails: func.isRequired,
  type: number.isRequired,
};

export default MonitoringQueueEntrySearchDetailsTableRow;



// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/components/searching/search-details-form/table/row/MonitoringQueueEntrySearchDetailsTableRow.jsx